<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 29.333c7.364 0 13.334-5.97 13.334-13.334 0-7.363-5.97-13.333-13.334-13.333-7.363 0-13.333 5.97-13.333 13.333 0 7.364 5.97 13.334 13.333 13.334zm.895-11.235c-.018.298-.303.533-.65.533h-.48c-.347 0-.633-.234-.65-.533l-.447-7.508c-.02-.321.277-.59.65-.59h1.365c.372 0 .669.268.65.589l-.438 7.509zm.439 2.482c0 .692-.597 1.253-1.334 1.253-.736 0-1.333-.561-1.333-1.253 0-.692.597-1.253 1.333-1.253.737 0 1.334.56 1.334 1.253z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsCircleAlertFilled'
}
</script>
